import {saveDesignRequest, getURLforPushInHistory} from "./save-design";
import {redirect} from "./redirect";
import {push} from "connected-react-router";
import {SAVE_DESIGN, START, SUCCESS, FAIL} from "../constants/action-types";
import Mediator from "../services/Mediator";
import trackPageview from "../../../utils/track-pageview";
import productSettings from "../services/product-settings";

const convertOptionsToStringWithVerticalLine = (options) =>
  Object.keys(options)
    .map((key) => `${key}:${options[key]}`)
    .join(`|`);

const getParams = (initialVariants, currentVariants, settings) => {
  if (settings && settings.variants) {
    const changingVariants = settings.variants.reduce(
      (acc, variant) => ({...acc, [variant.name]: true}),
      {}
    );
    const mergedVariants = Object.keys(currentVariants).reduce(
      (acc, variantKey) => {
        if (changingVariants[variantKey]) {
          return {...acc, [variantKey]: currentVariants[variantKey]};
        } else if (initialVariants[variantKey]) {
          return {...acc, [variantKey]: initialVariants[variantKey]};
        }
        return acc;
      },
      {}
    );
    return convertOptionsToStringWithVerticalLine(mergedVariants);
  }
  return ``;
};

export const orderProduct = () => (dispatch, getState) => {
  dispatch({
    type: SAVE_DESIGN + START
  });
  saveDesignRequest(dispatch, getState)
    .then((response) => {
      // change url
      if (response.product.id) {
        dispatch({
          type: SAVE_DESIGN + SUCCESS,
          response
        });
        Mediator.isDesignSaved = true;
        dispatch(push(getURLforPushInHistory(getState())));
      } else {
        throw new Error(`Ошибка сохранения`);
      }
    })
    .catch((error) => {
      dispatch({
        type: SAVE_DESIGN + FAIL,
        error
      });
      throw error;
    })
    .then(() => {
      const {
        initialVariants,
        mobileApp,
        condition: {variants: currentVariants, product},
        product: {closeup}
      } = getState();
      const settings = productSettings[product];
      const params = getParams(initialVariants, currentVariants, settings);
      const url = `${closeup}${params ? `?present[variant]=${params}` : ``}`;
      trackPageview({
        page: `/virtual/predmet-sozdan`
      });
      return mobileApp
        ? window.ReactNativeWebView.postMessage(
            JSON.stringify({
              product,
              closeup,
              variants: currentVariants
            })
          )
        : redirect(url);
    });
};
